const getColumns = ({totalData}) => [
  {
    id: 'type',
    Header: 'Tree species',
    accessor: 'type',
    customHeaderWidth: 100,
    Footer: 'Total'
  },
  {
    Header: 'Count',
    Footer: () => null,
    footerHidden: true,
    customHeaderWidth: 160,
    columns: [
        {
          Header: 'Total',
          accessor: 'total',
          Footer: () => <span>{totalData?.total}</span>,
          customAlignment: 'right',
        },
        {
          Header: '1 ha',
          accessor: 'per_ha',
          Footer: () => <span>{totalData?.per_ha}</span>,
          customAlignment: 'right'
        }
    ]
  },
  {
    Header: 'Healthy',
    Footer: () => null,
    footerHidden: true,
    customHeaderWidth: 160,
    columns: [
        {
          Header: 'Count',
          accessor: 'healthy',
          Footer: () => <span>{totalData?.healthy}</span>,
          customAlignment: 'right'
        },
        {
          Header: '%',
          accessor: 'healthy_pct',
          Footer: () => <span>{totalData?.healthy_pct}</span>,
          customAlignment: 'right'
        }
    ]
  },
  {
    Header: 'Infested',
    Footer: () => null,
    footerHidden: true,
    customHeaderWidth: 160,
    columns: [
        {
          Header: 'Count',
          accessor: 'infested',
          Footer: () => <span>{totalData?.infested}</span>,
          customAlignment: 'right'
        },
        {
          Header: '%',
          accessor: 'infested_pct',
          Footer: () => <span>{totalData?.infested_pct}</span>,
          customAlignment: 'right'
        }
    ]
  },
  {
    Header: 'Dead',
    Footer: () => null,
    footerHidden: true,
    customHeaderWidth: 160,
    columns: [
        {
          Header: 'Count',
          accessor: 'dead',
          Footer: () => <span>{totalData?.dead}</span>,
          customAlignment: 'right'
        },
        {
          Header: '%',
          accessor: 'dead_pct',
          Footer: () => <span>{totalData?.dead_pct}</span>,
          customAlignment: 'right'
        }
    ]
  },
  {
    id: 'avgHeight',
    Header: 'Avg. height',
    accessor: 'avg_height',
    Footer: () => <span>{totalData.avg_height}</span>,
    customAlignment: 'right'
  },
  {
    id: 'avgCrownDiam',
    Header: 'Avg. crown diameter',
    accessor: 'avg_crown_diam',
    Footer: () => <span>{totalData.avg_crown_diam}</span>,
    customAlignment: 'right'
  },
  {
    id: 'avgBhd',
    Header: 'Avg. BHD',
    accessor: 'avg_bhd',
    Footer: () => <span>{totalData.avg_bhd}</span>,
    customAlignment: 'right'
  },
  {
    id: 'avgVolume',
    Header: 'Avg. volume',
    accessor: 'avg_volume',
    Footer: () => <span>{totalData.avg_volume}</span>,
    customAlignment: 'right'
  },
];

export default getColumns;